(function (window, document, undefined) {

  window.cart_attr_gift = {

    init: () => {

      window.cart_attr_gift.addListeners();
      window.cart_attr_gift.check();
    
    },

    addListeners: () => {

      document.addEventListener('updateMiniCart', function(event) {
        window.cart_attr_gift.check();
      });

    },

    check: () => {

      fetch(`/cart.js`)
      .then((response) => response.json())
      .then((data) => {

        let c = document.querySelector('.cart_attr_gift');
        if (c) {
          let min_price_cents = c.getAttribute('data-min-price-cents') ? parseFloat(c.getAttribute('data-min-price-cents')) : 0;
          
          if (min_price_cents == 0) {
            window.cart_attr_gift.update('added');
          } else {
            if (data.total_price >= min_price_cents ) {
              window.cart_attr_gift.update('added');
            } else {
              window.cart_attr_gift.update('description_with_min_price');
            }
          } 
        }
      });

    },

    update: (status) => {

      console.log(`update`);

      let c = document.querySelector('.cart_attr_gift'),
          c_minicart = document.querySelector('.MiniCart_cart_attr_gift'),
          c_cart = document.querySelector('.Cart_cart_attr_gift');
      
      if (c) {
        console.log(`status : ${status}`);
        
        function addGift(json) {

          console.log(`addGift`);

          var _line_index = false,
              _line_qty = false,
              _html = `
                <div class="cart_attr_gift_product">
                  <div class="box">
                    <div class="box__image">
                      <figure>
                        <img src="${ c.getAttribute('data-img') }" alt="">
                      </figure>
                    </div>
                    <div class="box__description">${ c.getAttribute('data-t-description-added') }</div>
                  </div>
                </div>
                `;

          json.items.forEach((item, index) => {
            if (item.properties && item.properties.gift) {
              if (item.properties.gift != 'No') {
                _line_index = index;
                _line_qty = item.quantity;
              }
            }
          });

          if (_line_index === false) {

            console.log('a1b');
            console.log(`_line_qty: ${_line_qty}`);
            console.log(`_line_index: ${_line_index}`);

            json.items.forEach((item, index) => {
              if (index == 0) {
                _line_index = index + 1;
                _line_qty = item.quantity;
              }
            });

            let new_data = {
              properties: {
                gift : c.getAttribute('data-integration-title')
              }, 
              line: _line_index,
              quantity: _line_qty
            }
            
            fetch('/cart/change.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(new_data)
            }).then(function(response) {
              return response.json();
            }).then(function(json) {

              if (c_minicart) {
                c_minicart.innerHTML = _html;
              }

              if (c_cart) {
                c_cart.innerHTML = _html;
              }

            }).catch(function(err) {
              console.error(err);
            });
          } else {

            console.log('a2');

            if (c_minicart) {
              c_minicart.innerHTML = _html;
            }

            if (c_cart) {
              c_cart.innerHTML = _html;
            }

          }
        }

        function removeGift(json, status) {

          var _line_index = false,
              _line_qty = false,
              _html = false;

          if (status == 'description') {
            _html = `
              <div class="cart_attr_gift_product">
                <div class="box">
                  <div class="box__image">
                    <figure>
                      <img src="${ c.getAttribute('data-img') }" alt="">
                    </figure>
                  </div>
                  <div class="box__description">${ c.getAttribute('data-t-description') }</div>
                </div>
              </div>
            `;
          } else if (status == 'description_with_min_price') {
            _html = `
              <div class="cart_attr_gift_product">
                <div class="box">
                  <div class="box__image">
                    <figure>
                      <img src="${ c.getAttribute('data-img') }" alt="">
                    </figure>
                  </div>
                  <div class="box__description">${ c.getAttribute('data-t-description-with-min-price') }</div>
                </div>
              </div>
            `;
          }

          json.items.forEach((item, index) => {
            if (item.properties.gift) {
              if (item.properties.gift != 'No') {
                _line_index = item.key;
                _line_qty = item.quantity;
              }
            }
          });

          // console.log(`remove gift, _line_index : ${_line_index}, status: ${status}`);

          if (_line_index !== false) {

            console.log('r1e');
            console.log(`_line_qty: ${_line_qty}`);
            console.log(`_line_index: ${_line_index}`);

            let new_data = {
              properties: {
                gift : 'No'
              }, 
              quantity: _line_qty,
              id: _line_index
            };

            fetch('/cart/change.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(new_data)
            }).then(function(response) {
              return response.json();
            }).then(function(json) {
              
              if (status && _html != false && c_minicart) {
                c_minicart.innerHTML = _html;
              }

              if (status && _html != false &&  c_cart) {
                c_cart.innerHTML = _html;
              }

            }).catch(function(err) {
              console.error(err);
            });

          } else {

            console.log('r2');
              
            if (status && _html != false && c_minicart) {
              c_minicart.innerHTML = _html;
            }

            if (status && _html != false &&  c_cart) {
              c_cart.innerHTML = _html;
            }

          }

        }

        switch (status) {
          case 'added':

            fetch('/cart.js', {
              headers: {
                'Content-Type': 'application/json'
              },
              method: 'GET'
            }).then(function(response) {
              return response.json();
            }).then(function(json) {

              addGift(json, status);

            }).catch(function(err) {
              console.error(err);
            });
  
            break;
        
          case 'description':

            fetch('/cart.js', {
              headers: {
                'Content-Type': 'application/json'
              },
              method: 'GET'
            }).then(function(response) {
              return response.json();
            }).then(function(json) {

              removeGift(json, status);

            }).catch(function(err) {
              console.error(err);
            });
            
            break;
  
          case 'description_with_min_price':

            fetch('/cart.js', {
              headers: {
                'Content-Type': 'application/json'
              },
              method: 'GET'
            }).then(function(response) {
              return response.json();
            }).then(function(json) {

              removeGift(json, status);

            }).catch(function(err) {
              console.error(err);
            });
            
            break;
  
          default:

            break;
        }
      }

    }
  }

  window.cart_attr_gift.init();

})(window, window.document);
